// extracted by mini-css-extract-plugin
export var attribution = "_cp-4";
export var authorName = "_cp-5";
export var quote = "_cp-3";
export var testimonial = "_cp-2";
export var trustedBy = "_cp-0";
export var trustedByLabel = "_cp-1";